angular.module('bmsApp.merrymaids.job')
	.controller('MMReactivateJobsModalCtrl', [
		'$q',
		'ConfigService',
		'MMJobSvc',
		'$modalInstance',
		'customer',
		function ($q,
				  ConfigService,
				  MMJobSvc,
				  $modalInstance,
				  customer) {

			var self = this;

			angular.extend(self, {
				loading: false,
				loaded: false,
				errors: undefined,
				data: {
					customer: undefined,
					jobs: []
				},
				options: {},
				formValidator: {
					config: {
						errorPlacement: function (error) {
							error.appendTo('#form-errors');
						},
						errorContainer: '#form-errors'
					},
					api: {}
				},
				submitPromise: undefined,
				methods: {
					init: init,
					cancel: cancel,
					submit: submit
				},
				handlers: {
					reactivateChanged: onReactivateChanged
				}
			});

			function init() {
				self.loading = true;
				self.reactivateDateConfig = angular.copy(ConfigService.config.datePicker.basic);
				self.reactivateDateConfig.options.parentEl = 'modal-body';
				self.reactivateDateConfig.options.minDate = moment(); // today
				var reactivateOptionsPromise = MMJobSvc.reactivateOptions({
					customer_id: customer.id
				})
					.then(function (response) {
						self.data.customer = response.data.customer;
						angular.forEach(response.data.job_collection, function (job) {
							self.data.jobs.push(angular.extend(job, {
								reactivate: false,
								reactivate_date: null
							}));
						});
					});
				$q.all([
					reactivateOptionsPromise
				])
					.then(function () {
						self.loading = false;
						self.loaded = true;
					});
			}

			function cancel() {
				$modalInstance.dismiss('cancel');
			}

			function submit(form) {
				self.errors = undefined;
				if (form.$valid) {
					self.submitPromise = MMJobSvc.reactivate(self.data)
						.then(function () {
							$modalInstance.close({
								success: true
							});
						}, function (errors) {
							self.errors = errors;
						});
				}
			}

			function onReactivateChanged(job) {
				if (job.reactivate) {
					job.reactivate_date = moment()
						.format('YYYY-MM-DD');
				}
				else {
					job.reactivate_date = null;
				}
			}

		}
	]);
